// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SubpageMasthead__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SubpageMasthead/SubpageMasthead.scss
 ** module id = 943
 ** module chunks = 1
 **/